import { useQuery } from '@tanstack/react-query';
import { adminApi } from '@wa/shared';
import { Page, Stat } from '@/components/Primitives';

export function OverviewPage() {
  // Refreshed on a timer rather than by the hub: these are platform-wide counters,
  // and staff have no tenant claim, so they hold no hub connection at all.
  const overview = useQuery({
    queryKey: ['admin', 'overview'],
    queryFn: adminApi.overview,
    refetchInterval: 10_000,
  });

  const d = overview.data;

  return (
    <Page title="Overview" subtitle="Platform health across every tenant.">
      {overview.isPending && <p className="text-body text-(--color-muted)">Loading…</p>}

      {d && (
        <>
          <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-5">
            <Stat label="Active tenants" value={d.activeTenants} />
            <Stat label="Active channels" value={d.activeChannels} />
            <Stat label="Conversations" value={d.conversations} />
            <Stat label="Messages, 24h" value={d.messages24h} />
            <Stat label="Messages, total" value={d.messages} />
          </div>

          <h2 className="mt-8 text-small font-medium tracking-wide text-(--color-muted) uppercase">
            Needs attention
          </h2>
          <div className="mt-3 grid grid-cols-2 gap-3 md:grid-cols-4">
            <Stat label="Send queue depth" value={d.queueDepth} tone={d.queueDepth > 100 ? 'warn' : 'ink'} />
            <Stat label="Dead letters" value={d.deadLetters} tone={d.deadLetters > 0 ? 'bad' : 'good'} />
            <Stat label="Webhook backlog" value={d.webhookBacklog} tone={d.webhookBacklog > 50 ? 'warn' : 'ink'} />
            <Stat label="Failed sends, 24h" value={d.failed24h} tone={d.failed24h > 0 ? 'warn' : 'good'} />
          </div>
          <p className="mt-3 text-small text-(--color-muted)">
            Queue depth above zero is normal in flight. Dead letters are messages that will
            never send without someone looking at them.
          </p>
        </>
      )}
    </Page>
  );
}
